import BannerComp from "../components/BannerComp";
import ContactForm from "../components/ContactForm";
import Seo from "../components/Seo";
import { FaEnvelope, FaMapMarkerAlt, FaPhoneAlt } from "react-icons/fa";
import { contactInfo } from "../data/contactInfo";
import { createBreadcrumbSchema } from "../lib/seo";
import styles from "./Contact.module.css";

const seo = {
  title: "Contact Physicians Success Partners | Get Healthcare Support Today",
  description:
    "Contact Physicians Success Partners for expert medical billing, RCM, and healthcare support services. Our team is ready to assist your practice.",
  keywords:
    "contact medical billing company, healthcare billing consultation, PSP RCM contact",
  schema: [
    {
      "@context": "https://schema.org",
      "@type": "ContactPage",
      name: "Contact Physicians Success Partners",
      url: "https://psprcm.us/contact-us/",
      description:
        "Contact Physicians Success Partners for expert medical billing, RCM, and healthcare support services. Our team is ready to assist your practice.",
      mainEntity: {
        "@type": "Organization",
        name: "Physicians Success Partners",
        url: "https://psprcm.us/",
        logo: "https://psprcm.us/logo/main-logo.webp",
        contactPoint: [
          {
            "@type": "ContactPoint",
            telephone: "+1 6155536787",
            contactType: "customer service",
            areaServed: "US",
            availableLanguage: ["English"],
          },
          {
            "@type": "ContactPoint",
            email: "info@psprcm.us",
            contactType: "customer support",
            areaServed: "US",
            availableLanguage: ["English"],
          },
        ],
        address: {
          "@type": "PostalAddress",
          streetAddress: "1616 Westgate Circle",
          addressLocality: "Brentwood",
          addressRegion: "TN",
          postalCode: "37027",
          addressCountry: "USA",
        },
        sameAs: [
          "https://www.facebook.com/psprcmus",
          "https://www.instagram.com/psprcmus/",
          "https://www.pinterest.com/psprcmus/",
        ],
      },
    },
    createBreadcrumbSchema("/contact-us", "Contact Physicians Success Partners"),
  ],
};

export default function Contact() {
  return (
    <>
      <Seo
        title={seo.title}
        metaTitle={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        canonicalPath="/contact-us"
        schema={seo.schema}
      />
      <BannerComp
        heading="Let's Connect And Build Smarter Revenue Operations"
        paragraph="Reach out to our team for billing guidance, operational support, and practical next steps tailored to your organization."
        centered
      />

      <section className={styles.section}>
        <div className={`container ${styles.layout}`}>
          <div className={styles.contentCard}>
            <span className={styles.eyebrow}>Get In Touch</span>
            <h2>We're here to support your team with clear answers and dependable follow-through.</h2>
            <p className={styles.description}>
              Whether you need help improving collections, streamlining workflows, or understanding how PSP can support your practice, our team is ready to talk.
            </p>

            <div className={styles.contactList}>
              <a href={contactInfo.phoneHref} className={styles.contactItem}>
                <span className={styles.contactIcon} aria-hidden="true">
                  <FaPhoneAlt />
                </span>
                <span>
                  <strong>Call Us</strong>
                  <small>{contactInfo.phoneDisplay}</small>
                </span>
              </a>

              <a href={contactInfo.emailHref} className={styles.contactItem}>
                <span className={styles.contactIcon} aria-hidden="true">
                  <FaEnvelope />
                </span>
                <span>
                  <strong>Email Us</strong>
                  <small>{contactInfo.email}</small>
                </span>
              </a>

              <a
                href={contactInfo.addressMapHref}
                className={styles.contactItem}
                target="_blank"
                rel="noreferrer"
              >
                <span className={styles.contactIcon} aria-hidden="true">
                  <FaMapMarkerAlt />
                </span>
                <span>
                  <strong>Visit Us</strong>
                  <small>{contactInfo.address}</small>
                </span>
              </a>
            </div>
          </div>

          <div className={styles.formWrap}>
            <ContactForm />
          </div>
        </div>
      </section>
    </>
  );
}
